import { Box, Heading } from 'grommet';
import usePageTitle from 'hooks/usePageTitle';
import React from 'react';
import { connect } from 'rxbeach/react';
import { Asset } from 'types';
import NewsItems from './NewsItems';
import { newsViewModel$ } from './news$';

const NewsHome = ({ visibleNews }: { visibleNews: Asset[] }) => {
  usePageTitle('Nyheter');
  return (
    <>
      <Box align="center" justify="center" height="small" background="#F4F7FC">
        <Heading> Nyheter - Tønsberg Seilforening </Heading>
      </Box>
      <Box justify="center" align="center" pad="medium" gap="large">
        {visibleNews?.slice(0, 20).map((item) => (
          <NewsItems key={item.id} {...item} />
        ))}
      </Box>
    </>
  );
};

export default connect(NewsHome, newsViewModel$);
